import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehiculoService {
  private actualizacionVehiculos = new Subject<void>();
  actualizacionVehiculos$ = this.actualizacionVehiculos.asObservable();

  emitirActualizacion() {
    this.actualizacionVehiculos.next();
  }

  // Variables para cachear catálogos
  private marcas: any[] | null = null;
  private colores: any[] | null = null;
  private anios: any[] | null = null;
  private nivelesBlindaje: any[] | null = null;

  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  async cargarCatalogo(idCatalogo: number, parametros?: any[]): Promise<any[]> {
    if (idCatalogo === 32 && this.marcas) return this.marcas;
    if (idCatalogo === 3 && this.colores) return this.colores;
    if (idCatalogo === 20 && this.anios) return this.anios;
    if (idCatalogo === 5 && this.nivelesBlindaje) return this.nivelesBlindaje;

    const body: any = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia',
      },
      petition: {
        idCatalogo,
      },
    };

    if (parametros) {
      body.petition.parametros = parametros;
    }

    const cognitoId = localStorage.getItem('cognito') || '';
    const token = localStorage.getItem('accessToken') || '';

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': token,
    });

    try {
      const response = await this.http
        .post<any>(`${this.baseUrl}/user/${cognitoId}/catalog`, body, { headers })
        .toPromise();

      const catalogo = response.catalogo || [];

      // Guardar en caché según idCatalogo
      if (idCatalogo === 32) this.marcas = catalogo;
      else if (idCatalogo === 3) this.colores = catalogo;
      else if (idCatalogo === 20) this.anios = catalogo;
      else if (idCatalogo === 5) this.nivelesBlindaje = catalogo;

      return catalogo;
    } catch (error) {
      console.error(`Error al cargar catálogo ID ${idCatalogo}:`, error);
      return [];
    }
  }

  getMarcas() {
    return this.marcas;
  }

  getColores() {
    return this.colores;
  }

  getAnios() {
    return this.anios;
  }

  getNivelesBlindaje() {
    return this.nivelesBlindaje;
  }
}
